<template>
  <div class="row no-padding">

    <!-- Fullscreen Loader -->
    <FullscreenLoader v-if="screenLoader" />

    <!-- New UI -->
    <div class="new_visitReport">
      <div class="new_visitReport_title">Report a Visit</div>
      <div class="new_visitReport_header">
        <div class="new_visitReport_name">{{ capitalize(firstName) }} {{ capitalize(lastName) }}</div>
        <div class="new_visitReport_text mt-2">
          Employer:
          <span>
            {{ this.memberData?.employerPlanInfo?.companyName ? this.memberData?.employerPlanInfo?.companyName : "N/A" }}
          </span>
        </div>
        <div class="new_visitReport_text mt-2">
          Subscription Status: 
            <div :class="`new_visitReport_statusUI ${newVisitReportStatus(this.memberData?.history?.subscription?.status)}`">
              &bullet;&ensp; {{ this.memberData?.history ? this.memberData?.history?.subscription?.status  : "N/A" }}
            </div>
        </div>
        <div class="new_visitReport_text mt-2">
          Location:
          <span>
            {{ this.location !== '' ?  this.location : "N/A" }}
          </span>
        </div>
      </div>

      <div class="new_visitReport_form mt-5">
        <v-form ref="visitReportForm" v-model="visitReportForm">
          <!-- Select Date of Service -->
          <div class="new_visitReport_form_row">
            <div class="new_visitReport_form_row_name">Select Date of Service</div>
            <!-- Date Picker -->
            <v-dialog v-model="datePickerDialog" persistent width="290px">
              <v-date-picker 
                v-model="visitReportDate" 
                @input="datePickerDialog = false" 
                :show-current="true"
                :max="maxDate"
              ></v-date-picker>
            </v-dialog>
            <!-- Input Field -->
            <v-text-field
              required dense outlined
              placeholder="Please select a date"
              class="new_visitReport_datePicker mt-2"
              v-model.trim="finalVisitReportDate"
              @click="openDatePicker()"
              :rules="requiredRules"
            ></v-text-field>
          </div>

          <!-- Select Provider -->
          <div class="new_visitReport_form_row">
            <div class="new_visitReport_form_row_name">Select Provider</div>
            <v-autocomplete
              required outlined dense
              label="Search for Provider"
              class="autoCompleteStyle mt-2"
              :items="providerItems"
              item-text="providerName"
              item-value="_id"
              v-model.trim="providerId"
              :rules="requiredRules"
            ></v-autocomplete>
          </div>

          <!-- Visit Type -->
          <div class="new_visitReport_form_row new_visitReport_form_row_visitTypes">
            <!-- Wellness -->
            <button :class="`new_visitReport_visitType ${isWellness ? 'new_visitReport_visitType_active':''}`" @click.prevent="isWellness = true">
              <img src="/icon_heart.svg" class="new_visitReport_visitType_icon">
              Wellness
            </button>

            <!-- Sick Visir=t -->
            <button :class="`new_visitReport_visitType ${!isWellness ? 'new_visitReport_visitType_active':''}`" @click.prevent="isWellness = false">
              <img src="/icon_sick.svg" class="new_visitReport_visitType_icon">
              Sick Visit
            </button>
          </div>

          <!-- If Sick Visit, show Diagnosis Option -->
          <div class="new_visitReport_form_row mt-6" v-if="!isWellness">

            <div class="new_visitReport_form_row_name">Enter Diagnosis</div>
            <!-- Autocomplete UI -->
            <v-autocomplete
              @change="selectDiagnosis"
              :search-input.sync="clinicaltables"
              :items="clinicaltableData"
              item-text="name"
              item-value="code"
              label="Search for Diagnosis"
              return-object
              outlined dense required
              class="autoCompleteStyle mt-2"
              :rules="requiredRules"
              no-data-text="Please type diagnosis"
            >
              <template v-slot:item="{ item }">
                <div class="autoCompleteList">
                  <div class="autoCompleteOption">
                    {{ item.code +" - "+ item.name}}
                  </div>
                </div>
              </template>
            </v-autocomplete>
          </div>

          <!-- Buttons -->
          <div class="new_visitReport_form_row new_visitReport_actions">
            <button class="new_visitReport_actions_btn_cancel" @click.prevent="cancel()">
              Cancel
            </button>
            <button class="new_visitReport_actions_btn_go" :disabled="!visitReportForm" @click.prevent="submitNewVisitReport()">
              <img src="/icon_submit.svg" class="new_visitReport_actions_icon">
              Submit Report
            </button>
          </div>

        </v-form>
      </div>
    </div>

    <!-- Old UI -->
    <div
      style="display: none;"
      class="row-height mb-4 col-md-12 no-paddng"
      v-if="!isChildren"
      :class="showOverlay ? ' postion-relative' : ''"
    >
      <div
        class="wizard-absolute border-r-8 mt-4"
        v-if="showOverlay"
        @click="(dialog = false), (dialog1 = false), (showOverlay = false)"
      ></div>
      <div class="col-md-12 no-padding no-margin">
        <v-row align="center" justify="center">
          <div class="pa-3 col-md-12 navigationWidth no-padding">
            <v-row class="blue-underline mb-1" style="height: 90px !important">
              <v-col class="col-xl-2 col-md-2 cols-4 pt-2 pb-0" cols="4">
                <div class="col-md-12">
                  <h3 class="form-title font col-md-12 font-18">Visit Reporting</h3>
                </div>
              </v-col>

              <v-col
                class="ml-auto col-xl-4 col-lg-5 d-flex col-md-4 pt-4 pr-2 cols-12 text-end"
                cols="12"
                align="end"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{}">
                    <a
                      @click="$router.push('/dpc-providers/members/new-template')"
                      class="my-1 mr-4 mt-4 text-underline"
                    >
                      New Template
                    </a>
                    <a @click="editTemplate(template)" class="my-1 mr-4 mt-4 text-underline">
                      Edit Template
                    </a>
                    <div class="mt-3 mr-3" style="width: 30%">
                      <v-select
                        solo
                        item-text="title"
                        item-value="_id"
                        v-model="template"
                        :items="templates"
                        return-object
                        dense
                        single-line
                        placeholder="Select Template"
                      ></v-select>
                    </div>
                    <a class="my-1 mr-4 mt-4 text-underline" @click="changeTemplate(template)">
                      Apply
                    </a>
                  </template>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </div>
      <v-row class="no-paddng d-block">
        <div class="col-xl-3 col-lg-3 col-md-12 float-left no-padding">
          <v-col class="pl-lg-0">
            <div class="text-center" style="cursor: pointer">
              <v-row class="mx-2 justify-center mt-1 mb-2">
                <h5 class="text-center mt-4 font-quicksand-medium-18">
                  Patient Information
                </h5>
              </v-row>
              <v-row class="mx-0 mt-3 text-left pl-5 pr-5">
                <v-form ref="form" v-model.trim="valid" class="col-md-12 no-padding">
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">First Name </label>
                    <v-text-field
                      v-model.trim="firstName"
                      hide-details
                      class="rounded-xl"
                      disabled
                      outlined
                    ></v-text-field>
                  </div>
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">Last Name </label>
                    <v-text-field
                      v-model.trim="lastName"
                      hide-details
                      disabled
                      class="rounded-xl"
                      outlined
                    ></v-text-field>
                  </div>
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">DOB</label>
                    <v-menu
                      ref="menu"
                      v-model.trim="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      class="rounded-xl"
                      disabled
                      min-width="auto"
                    >
                      <v-btn color="success">text</v-btn>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="rounded-xl"
                          v-model.trim="dob"
                          outlined
                          hide-details
                          append-icon="mdi-calendar"
                          readonly
                          disabled
                          persistent-hint
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model.trim="dob"
                        no-title
                        class="rounded-xl"
                        disabled
                        @input="menu = false"
                      >
                        <v-spacer></v-spacer>
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <div
                    class="col-md-12 padding-for-inputs mt-3 mb-3"
                    style="pointer-events: none"
                  >
                    <label for="" class="text-left">Gender</label>
                    <div class="row col-md-12">
                      <div
                        class="text-end rounded-lg"
                        :disabled="disabled"
                        :class="gender == 'm' ? 'fill-blue-checkbox' : 'blue-checkbox'"
                        @click="gender = 'm'"
                      ></div>
                      <span class="ml-2 text-gray">Male</span>

                      <div
                        class="text-end ml-8 rounded-lg"
                        :disabled="disabled"
                        :class="gender == 'f' ? 'fill-blue-checkbox' : 'blue-checkbox'"
                        @click="gender = 'f'"
                      ></div>
                      <span class="ml-2 text-gray">Female</span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">Relationship to Subscriber</label>
                    <v-select
                      outlined
                      class="rounded-xl"
                      disabled
                      :items="subscriberItems"
                      :rules="requiredRules"
                      hide-details
                      v-model.trim="subscriberRelation"
                    ></v-select>
                  </div>
                </v-form>
                <br /><br />
              </v-row>
              <v-row class="mx-2 justify-center mt-2 mb-2">
                <h5 class="text-center mt-4 font-quicksand-medium-18">
                  Encounter Information
                </h5>
              </v-row>
              <v-row class="mx-0 mt-3 text-left pl-5 pr-5">
                <v-form ref="form" v-model.trim="valid" class="col-md-12 no-padding">
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">Date of Service</label>
                    <v-menu
                      ref="menu"
                      class="rounded-xl"
                      v-model.trim="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model.trim="dateOfService"
                          @blur="dateOfService = parseDate(dateOfService)"
                          outlined
                          v-mask="'####-##-##'"
                          hide-details
                          class="rounded-xl"
                          append-icon="mdi-calendar"
                          persistent-hint
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <!-- <v-date-picker
                        class="rounded-xl"
                        no-title
                        :reactive="true"
                      >
                        <v-spacer></v-spacer>
                      </v-date-picker> -->
                    </v-menu>
                  </div>
                  <div class="col-md-12 padding-for-inputs">
                    <label for="" class="text-left">Location</label>
                    <v-text-field
                      v-model.trim="location"
                      class="rounded-xl"
                      hide-details
                      disabled
                      outlined
                    ></v-text-field>
                  </div>
                  <div class="col-md-12 padding-for-inputs mb-4">
                    <label for="" class="text-left">Provider</label>
                    <v-select
                      required
                      outlined
                      class="rounded-xl"
                      :items="providerItems"
                      item-text="providerName"
                      item-value="_id"
                      :rules="requiredRules"
                      hide-details
                      v-model.trim="providerId"
                    ></v-select>
                  </div>
                </v-form>
                <br /><br />
              </v-row>
            </div>
          </v-col>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 row float-left">
          <div class="col-xl-6 col-lg-6 col-md-9 mt-1 pr-0">
            <div class="col-xl-12 col-lg-12 col-md-12 mt-1 pr-0 mr-1">
              Diagnosis Information |
              <a class="blue-text" @click="openFavoriteDiagnosesDialog()"> Favorites</a>
              <br />
              <div>
                <div class="col-10 zero-padding">
                  <label for="" class="text-left mt-2 mb-2" @click="searchDiagnose()"
                    >Search for Diagnosis
                  </label>
                </div>
                <div class="d-flex">
                  <span>
                    <v-text-field
                      class="input-control mr-5 mt-1"
                      @keypress.enter="searchDiagnose"
                      v-model="diagnoseSearch"
                      light
                      dense
                      outlined
                    ></v-text-field>
                  </span>
                  <span class="mt-2">
                    <a class="text-underline blue-text" @click="searchDiagnose()"
                      >Search
                    </a>
                  </span>
                </div>
                <template>
                  <v-row justify="center">
                    <v-dialog
                      v-model="DiagnosisDialog"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                    >
                      <v-card>
                        <v-card-title class="mb-1">
                          <v-row class="blue-underline mb-3 mt-1">
                            <div class="mb-3 ml-1 d-flex">
                             <a class="mr-1" role="button"> Diagnoses</a> |
                              <p @click="openFavoriteDiagnosesDialog()" class="ml-1" role="button">Favorites</p>
                            </div>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-simple-table fixed-header height="50vh">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Index</th>
                                  <th class="text-left">Description</th>
                                  <th class="text-left">ICD Code</th>
                                  <th class="text-left">Favorite</th>
                                  <th class="">Select</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr v-for="(item, index) in diagnose" :key="index">
                                  <td>
                                    {{ index + 1 }}
                                  </td>
                                  <td>{{ item.description }}</td>
                                  <td>{{ item.code }}</td>
                                  <td @click="addFavoriteIcd(item, index)">
                                    <v-rating
                                      color="yellow darken-3"
                                      background-color="grey darken-1"
                                      hover
                                      :value="item.star"
                                      length="1"
                                    ></v-rating>
                                  </td>
                                  <td class="">
                                    <v-checkbox
                                      color="primary"
                                      @click="checkIcds(item)"
                                      v-model="tmpIcds"
                                      :value="item._id"
                                    ></v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                              <v-progress-circular
                                style="margin-left: 20vw"
                                v-if="loader"
                                color="primary"
                                indeterminate
                              ></v-progress-circular>
                            </template> </v-simple-table
                        ></v-card-text>
                        <v-card-actions style="border-top: 1px solid rgb(209, 207, 207)">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="DiagnosisDialog = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="addICDS()"
                          >
                            Add Selected
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
                <template>
                  <v-row justify="center">
                    <v-dialog
                      v-model="FavoriteDiagnosis"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                    >
                      <v-card>
                        <v-card-title class="mb-1">
                          <v-row class="blue-underline mb-3 mt-1">
                            <div class="mb-3 ml-1 d-flex"><p @click="openDiagnosesDialog()" class="mr-1" role="button"> Diagnoses </p> | <a class="ml-1">Favorites</a></div>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-simple-table fixed-header height="50vh">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Favorites</th>
                                  <th class="text-left">Description</th>
                                  <th class="text-left">ICD Code</th>
                                  <th class="text-left">Favorite</th>
                                </tr>
                              </thead>
                              <tbody v-for="(item, index) in favoriteDiagnoses" :key="index">
                                <tr>
                                  <td>
                                    {{ index + 1 }}
                                  </td>
                                  <td>{{ item.description }}</td>
                                  <td>{{ item.code }}</td>
                                  <td  @click="manageFavoriteIcd(item, index)"> 
                                    <v-rating
                                      color="yellow darken-3"
                                      background-color="grey darken-1"
                                      hover
                                      :value="1"
                                      length="1"
                                  ></v-rating>
                                  </td>
                                </tr>
                              </tbody>
                            </template> </v-simple-table
                        ></v-card-text>
                        <v-card-actions style="border-top: 1px solid rgb(209, 207, 207)">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteDiagnosis = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteDiagnosis = false"
                          >
                            Add Selected
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </div>
              <v-simple-table
                fixed-header
                height="330px"
                style="margin-top: 45px !important"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Rank</th>
                      <th class="text-left">ICD Code</th>
                      <th class="text-left">Description</th>
                      <th class="">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in icds" :key="index">
                    <tr>
                      <td
                        style="background-color: #efefef; width: 65px !important"
                        class="d-flex pl-0"
                      >
                        <v-icon
                          style="font-size: 18px !important"
                          @click="moveIcd(index, index - 1)"
                          :disabled="index == 0"
                        >mdi-arrow-up
                        </v-icon>
                        <v-icon
                          style="font-size: 18px !important"
                          @click="moveIcd(index, index + 1)"
                          :disabled="index == item.length - 1"
                        >mdi-arrow-down
                        </v-icon>
                        <p class="mt-3 font-bold">
                          {{ index + 1 }}
                        </p>
                      </td>
                      <td>{{ item.code }}</td>
                      <td>{{ item.description }}</td>
                      <td class="">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          @click="removeFromIcds(item)"
                        >
                          <path
                            d="M16.7498 9.3335L9.41211 16.6668"
                            stroke="#DC0101"
                            stroke-width="2.4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.41211 9.3335L16.7498 16.6668"
                            stroke="#DC0101"
                            stroke-width="2.4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.1957 2H6.96607C4.26438 2 2.07422 4.18883 2.07422 6.88889V19.1111C2.07422 21.8112 4.26438 24 6.96607 24H19.1957C21.8974 24 24.0876 21.8112 24.0876 19.1111V6.88889C24.0876 4.18883 21.8974 2 19.1957 2Z"
                            stroke="#DC0101"
                            stroke-width="2.4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 pr-lg-0 col col-12">
            <div class="col-xl-12 col-lg-12 col-md-12 mt-1 pr-0">
              <div class="col-12 d-flex zero-padding">
                <span class="col-7 zero-padding-top" style="display: grid">
                  <span>
                    Procedure Information |
                    <a class="blue-text" @click="openFavoriteProcedureDialog()"> Favorites</a>
                  </span>
                  <span>
                    <label for="" class="text-left mt-2 mb-2" @click="searchProcedure()"
                      >Search for Procedure
                    </label>
                  </span>
                  <span class="d-flex">
                    <v-text-field
                      style="width: 70%"
                      class="input-control mr-5 mt-1"
                      @keypress.enter="searchProcedure"
                      v-model="procedureSearch"
                      light
                      dense
                      outlined
                    ></v-text-field>
                    <a class="text-underline mt-2" @click="searchProcedure()">Search </a>
                  </span>
                </span>
                <span
                  style="
                    border: 1px solid grey;
                    display: inline-table;
                    font-weight: bolder;
                  "
                  class="col-4 ml-3 text-center"
                >
                  {{ noTitle ? noTitle : templateForEdit?.title }} Applied <br />

                  <a @click="defaultTemplate()" class="blue-text text-underline"
                    >Click to Cancel</a
                  >
                </span>
              </div>
              <br />
              <div class="col-12 p-0">
                <v-dialog
                  hide-overlay
                  v-model.trim="errorModal"
                  height="320"
                  width="400"
                  style="margin-top: 30vh"
                  content-class="modal-member-check"
                >
                  <v-card>
                    <v-card-text>
                      <div
                        class="col-md-12 pt-10 text-center"
                        @click="errorModal = false"
                      >
                        <div class="red-error-modal">
                          <svg
                            class="mt-3"
                            width="37"
                            height="37"
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                              stroke="#E40000"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M34 21L19 36"
                              stroke="#E40000"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19 21L34 36"
                              stroke="#E40000"
                              stroke-width="3"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <div class="error-modal-red-text">
                            Please choose a diagnose first
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <template>
                  <v-row justify="center">
                    <v-dialog
                      v-model="FavoriteProcedure"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                    >
                      <v-card>
                        <v-card-title class="mb-1">
                          <v-row class="blue-underline mb-3 mt-1">
                            <div class="mb-3 ml-1 d-flex">
                             <p @click="openProcedureDialog()" class="mr-1" role="button">Procedures</p>  | <a class="ml-1" role="button">Favorites</a>
                            </div>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-simple-table fixed-header height="50vh">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Favorites</th>
                                  <th class="text-left">Description</th>
                                  <th class="text-left">ICD Code</th>
                                  <th class="text-left">Favorite</th>
                                </tr>
                              </thead>
                              <tbody v-for="(item, index) in favoriteProcedures" :key="index">
                                <tr>
                                  <td>
                                    {{ index + 1 }}
                                  </td>
                                  <td>{{ item.description }}</td>
                                  <td>{{ item.code }}</td>
                                  <td @click="manageFavoriteCpts(item,index)">
                                    <v-rating
                                      color="yellow darken-3"
                                      background-color="grey darken-1"
                                      hover
                                      :value="1"
                                      length="1"
                                    ></v-rating>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table></v-card-text
                        >
                        <v-card-actions style="border-top: 1px solid rgb(209, 207, 207)">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false"
                          >
                            Add Selected
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
                <template>
                  <v-row justify="center">
                    <v-dialog
                      v-model="ProcedureDialog"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                    >
                      <v-card>
                        <v-card-title class="mb-1">
                          <v-row class="blue-underline mb-3 mt-1">
                            <div class="mb-3 ml-1 d-flex">
                             <a class="mr-1" role="button">Procedures</a>  |
                              <p @click="openFavoriteProcedureDialog()" class="ml-1" role="button">Favorites</p>
                            </div>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-simple-table fixed-header height="50vh">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Index</th>
                                  <th class="text-left">Description</th>
                                  <th class="text-left">CPT Code</th>
                                  <th class="text-left">Favorite</th>
                                  <th class="">Select</th>
                                </tr>
                              </thead>

                              <v-progress-circular
                                style="margin-left: 20vw"
                                v-if="loader"
                                color="primary"
                                indeterminate
                              ></v-progress-circular>
                              <tbody v-for="(item, index) in procedure" :key="index">
                                <tr>
                                  <td>
                                    {{ index + 1 }}
                                  </td>
                                  <td>{{ item.description }}</td>
                                  <td>{{ item.code }}</td>
                                  <td @click="addFavoriteCpt(item, index)">
                                    <v-rating
                                      color="yellow darken-3"
                                      background-color="grey darken-1"
                                      hover
                                      :value="item.star"
                                      length="1"
                                    ></v-rating>
                                  </td>
                                  <td class="">
                                    <v-checkbox
                                      color="primary"
                                      @click="checkCpts(item)"
                                      v-model="tmpCpts"
                                      :value="item._id"
                                    >
                                    </v-checkbox>
                                  </td>
                                </tr>
                              </tbody>
                            </template> </v-simple-table
                        ></v-card-text>
                        <v-card-actions style="border-top: 1px solid rgb(209, 207, 207)">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="ProcedureDialog = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="addCPTS()"
                          >
                            Add Selected
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
              </div>

              <br />
              <br />
              <v-simple-table
                fixed-header
                height="430px"
                style="margin-top: -80px !important"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Rank</th>
                      <th class="text-left">Descritpion</th>
                      <!-- <th class="text-left">Modifiers</th> -->
                      <th class="text-left">Qty</th>
                      <th class="text-left">Diagnosis Link</th>
                      <th class="">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in cpts" :key="index">
                    <tr>
                      <td
                        style="background-color: #efefef; width: 55px !important"
                        class="d-flex pl-0"
                      >
                        <v-icon
                          style="font-size: 18px !important"
                          @click="moveCpt(index, index - 1)"
                          :disabled="index == 0"
                        >md-arrow-up
                        </v-icon>
                        <v-icon
                          style="font-size: 18px !important"
                          @click="moveCpt(index, index + 1)"
                          :disabled="index == item.length - 1"
                        >mdi-arrow-down
                        </v-icon>
                        <p class="mt-3 font-bold">
                          {{ index + 1 }}
                        </p>
                      </td>
                      <td>{{ item.cpt ? item.cpt.description : item.description }}</td>
                      <!-- <td>{{item.modifiers}}</td> -->
                      <td>
                        <v-select
                          class="pt-3"
                          solo
                          :items="numbers"
                          style="width: 70px"
                          v-model="item.quantity"
                        >
                        </v-select>
                      </td>
                      <td>
                        <v-select
                          solo
                          class="pt-3"
                          :items="itemIcds"
                          style="width: 160px"
                          item-value="_id"
                          item-text="code"
                          v-model="item.icdLink"
                        >
                        </v-select>
                      </td>
                      <td class="">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              style="background-color: none; border: none"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.85742 13.7141L10.3717 16.5255C10.4661 16.6032 10.5766 16.6589 10.6952 16.6886C10.8138 16.7183 10.9376 16.7211 11.0574 16.6969C11.1784 16.6742 11.2931 16.6257 11.3937 16.5547C11.4943 16.4837 11.5784 16.3919 11.6403 16.2855L17.1431 6.85693"
                                  stroke="#09951F"
                                  stroke-width="1.71429"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.0003 23.1426C18.1543 23.1426 23.1431 18.1538 23.1431 11.9998C23.1431 5.84576 18.1543 0.856934 12.0003 0.856934C5.84625 0.856934 0.857422 5.84576 0.857422 11.9998C0.857422 18.1538 5.84625 23.1426 12.0003 23.1426Z"
                                  stroke="#09951F"
                                  stroke-width="1.71429"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="getModifiers()" class="mb-5">
                              <v-list-item-title
                                style="color: #0573f3; text-decoration: underline"
                                >Add Modifier
                              </v-list-item-title>
                            </v-list-item>
                            <template>
                              <v-row justify="center">
                                <v-dialog
                                  v-model="modifiersList"
                                  persistent
                                  max-width="80vw"
                                  max-height="60vh"
                                >
                                  <v-card>
                                    <v-card-title class="mb-1">
                                      <v-row class="blue-underline mb-3 mt-1">
                                        <div class="mb-3 ml-1 d-flex">
                             <a class="mr-1" role="button">Modifiers</a>  |
                              <p @click="openFavoriteModifiersDialog()" class="ml-1" role="button">Favorites</p>
                            </div>
                                      </v-row>
                                    </v-card-title>
                                    <v-card-text>
                                      <v-simple-table fixed-header height="50vh">
                                        <template v-slot:default>
                                          <thead>
                                            <tr>
                                              <th class="text-left">Index</th>
                                              <th class="text-left">Code</th>
                                              <th class="text-left">Description</th>
                                              <th class="text-left">Favorite</th>
                                              <th class="">Select</th>
                                            </tr>
                                          </thead>
                                          <tbody
                                            v-for="(item, index) in modifiers"
                                            :key="index"
                                          >
                                            <tr>
                                              <td>
                                                {{ index + 1 }}
                                              </td>
                                              <td>{{ item.description }}</td>
                                              <td>{{ item.code }}</td>
                                              <td @click="addFavoriteModifiers(item, index)">
                                             <v-rating
                                              color="yellow darken-3"
                                             background-color="grey darken-1"
                                              hover
                                             :value="item.star"
                                             length="1"
                                           ></v-rating>
                                            </td>
                                              <td class="">
                                                <v-checkbox
                                                  color="primary"
                                                  @click="checkCptmod(item)"
                                                  v-model="tmpCptmod"
                                                  :value="item._id"
                                                >
                                                </v-checkbox>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template> </v-simple-table
                                    ></v-card-text>
                                    <v-card-actions
                                      style="border-top: 1px solid rgb(209, 207, 207)"
                                    >
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="primary"
                                        class="text-underline"
                                        text
                                        @click="modifiersList = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        color="primary"
                                        class="text-underline"
                                        text
                                        @click="
                                          addCPTmod();
                                          modifiersList = false;
                                        "
                                      >
                                        Add Selected
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-row>
                            </template>
                            <template>
                  <v-row justify="center">
                    <v-dialog
                      v-model="favModifiersDialog"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                    >
                      <v-card>
                        <v-card-title class="mb-1">
                          <v-row class="blue-underline mb-3 mt-1">
                            <div class="mb-3 ml-1 d-flex">
                             <p @click="openModifiersDialog()" class="mr-1" role="button">Modifiers</p>  | <a class="ml-1" role="button">Favorites</a>
                            </div>
                          </v-row>
                        </v-card-title>
                        <v-card-text>
                          <v-simple-table fixed-header height="50vh">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Favorites</th>
                                  <th class="text-left">Description</th>
                                  <th class="text-left">ICD Code</th>
                                  <th class="text-left">Favorite</th>
                                </tr>
                              </thead>
                              <tbody v-for="(item, index) in favoriteModifiers" :key="index">
                                <tr>
                                  <td>
                                    {{ index + 1 }}
                                  </td>
                                  <td>{{ item.description }}</td>
                                  <td>{{ item.code }}</td>
                                  <td @click="manageFavoriteModifiers(item,index)">
                                    <v-rating
                                      color="yellow darken-3"
                                      background-color="grey darken-1"
                                      hover
                                      :value="1"
                                      length="1"
                                    ></v-rating>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table></v-card-text
                        >
                        <v-card-actions style="border-top: 1px solid rgb(209, 207, 207)">
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false"
                          >
                            Add Selected
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>
                            <v-list-item>
                              <v-list-item-title
                                style="color: #0573f3; text-decoration: underline"
                                @click="removeFromCpt(item)"
                                >Delete Procedure</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </div>
      </v-row>
    </div>
    <div class="col-md-12 no-padding" style="display: none;">
      <div class="gray-underline-wizard row margin-l-11 pr-10">
        <div class="text-end justify-end col-md-12 mt-5 mb-5">
          <span
            class="mr-10 text-underline pointer"
            style="color: #1976d2"
            @click="cancel()"
            >Cancel</span
          >
          <span
            class="mr-3 text-underline pointer"
            style="color: #1976d2"
            @click="submitVisitReport()"
            >Submit
          </span>
        </div>
      </div>
    </div>

    <!-- Success Modal -->
    <successModal ref="success_modal" v-on:confirm="closeSuccessModal"></successModal>

    <!-- Choose Provider Modal -->
    <v-dialog
      hide-overlay
      v-model.trim="errorProvider"
      height="320"
      width="400"
      style="margin-top: 30vh"
      content-class="modal-member-check"
    >
      <v-card>
        <v-card-text>
          <div class="col-md-12 pt-10 text-center" @click="errorProvider = false">
            <div class="red-error-modal">
              <svg
                class="mt-3"
                width="37"
                height="37"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34 21L19 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 21L34 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="error-modal-red-text">Please choose a Provider first!</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Cannot Search Empty Field Modal -->
    <v-dialog
      hide-overlay
      v-model.trim="emptySearch"
      height="320"
      width="400"
      style="margin-top: 30vh"
      content-class="modal-member-check"
    >
      <v-card>
        <v-card-text>
          <div class="col-md-12 pt-10 text-center" @click="emptySearch = false">
            <div class="red-error-modal">
              <svg
                class="mt-3"
                width="37"
                height="37"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M34 21L19 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M19 21L34 36"
                  stroke="#E40000"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="error-modal-red-text">Cannot search an empty field!</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Erro Modal -->
    <errorModal ref="error_modal" v-on:confirm="closeErrorModal"> </errorModal>

    <router-view></router-view>
  </div>
</template>

<script>
import api from "../../../../services/api";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";
import errorModal from "../../../TablesTemplate/ErrorDialog.vue";
import moment from "moment";
import FullscreenLoader from "../../../Common/FullscreenLoader.vue";

import { mapGetters } from "vuex";
Array.prototype.moveIcd = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};
Array.prototype.moveCpt = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};
export default {
  components: { successModal, errorModal, FullscreenLoader },

  data() {
    return {
      screenLoader: false,
      visitReportForm: false, // Visit Reporting Form
      isWellness: true,
      datePickerDialog: false,
      maxDate: moment.utc(new Date()).format('YYYY-MM-DD'), // Today's date in YYYY-MM-DD format
      visitReportDate: moment.utc().format('YYYY-MM-DD'), // Visit Report Date of Service for the datepicker (default format)
      finalVisitReportDate: moment.utc(new Date()).format('MM/DD/YYYY'), // Final Visit Report Date to be pushed in BE (MM/DD/YYYY)
      clinicaltables: "", // Search Field
      clinicaltableData: [], // Search Results
      selectedDiagnosis: {}, // Selected Diagnosis
      memberData:{},
      emptySearch: false,
      noDiagnosis: false,
      noProcedure: false,
      templateForEdit: {},
      noTitle: "",
      errorProvider: false,
      errorModal: false,
      loader: false,
      quantity: "1",
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      list: [],
      disabled: true,
      modifiersList: false,
      openMenu: false,
      DiagnosisDialog: false,
      ProcedureDialog: false,
      FavoriteDiagnosis: false,
      FavoriteProcedure: false,
      icds: [],
      itemIcds: [],
      icdList: [],
      tmpIcds: [],
      tmpCpts: [],
      favCpt: 0,
      facIcd: 0,
      favoriteIcd: [],
      favoriteCpt: [],
      cptmod: [],
      tmpCptmod: [],
      cpts: [],
      results: [],
      diagnose: [],
      procedure: [],
      templates: [],
      modifiers: [],
      favoriteDiagnoses: [],
      favoriteProcedures: [],
      favoriteModifiers: [],
      favModifiersDialog: false,
      iconUp: "mdi-arrow-up",
      iconDown: "mdi-arrow-down",
      template: {
        title: "Wellness",
        _id: "63b80bf071c8d13a391d6918",
      },
      visitor: {
        member: null,
      },
      diagnoseSearch: "",
      procedureSearch: "",
      phone: "",
      _id: "",
      firstName: "",
      lastName: "",
      email: "",
      dob: "",
      menu: "",
      gender: "m",
      location: "",
      locationId: "",
      dateOfService: "",
      serviceDate: "",
      providerItems: [],
      providers: [],
      providerId: "",
      subscriberItems: ["Self", "Spouse", "Dependent"],
      subscriberRelation: "",
      showOverlay: false,
      states: [],
      discountRate: "",
      valid: false,
      requiredRules: [(v) => !!v || "This field is required"],
      
    };
  },
  computed: {
    ...mapGetters(["getEligibilityMember"]),
    getIcdsList() {
      return this.icds;
    },
    getCptList() {
      return this.cpts;
    },
    getCptmodList() {
      return this.cptmod;
    },
    singleEmp() {
      let provider = "";
      if (localStorage.getItem("employer")) {
        provider = JSON.parse(localStorage.getItem("employer"));
      }

      return provider;
    },
    isChildren() {
      let bool = false;
      if (this.$route.meta && this.$route.meta.isChildren) {
        bool = true;
      }
      return bool;
    },
  },
  async created() {
    const self = this;
    this.getFavs();
    this.getMember();
    await this.getTemplates();
    api()
      .get(`/dpcproviders/visitreport?member=${this.$route.params.id}`)
      .then((res) => {
        if (res) {
          // console.log("visitor: ", res.data);
          this.visitor = res.data;
          this.firstName = this.visitor.member.firstName;
          this.lastName = this.visitor.member.lastName;
          this.location = this.visitor.location.name;
          this.locationId = this.visitor.location._id;
          this.dob = this.visitor.member.dob.substring(0, 10);
          this.dateOfService = this.visitor.serviceDate.substring(0, 10);
          this.serviceDate = this.visitor.serviceDate;
          this.gender = this.visitor.member.gender;
          this.subscriberRelation = this.visitor.member.subscriberRelation;
          this.providerItems = this.visitor.providers;
          this.icds = this.visitor.templates[0]?.icds;
          this.tmpCpts = this.visitor.templates[0]?.cpts;
          this.cpts = this.visitor.templates[0]?.cpts;
          let mods = [];
          this.itemIcds = this.icds;
          this.cpts.forEach(item => {
            if (!item.hasOwnProperty('quantity')) {
          this.$set(item, 'quantity', '1');
        }
        });
        }
      });

  },
  watch: {
    visitReportDate(nVal) {
      // alert(nVal);
      this.finalVisitReportDate = moment.utc(nVal).format('YYYY-MM-DD');
    },
    clinicaltables(newVal) {
      this.clinicaltablesSearch();
    }
  },
  methods: {
    capitalize(string) {
        if (string) {
            // Capitalize the first letter the string
            return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }
        return ''
    },
    submitNewVisitReport() {

      // Screen Loader
      this.screenLoader = true;

      let body = {};
      if(this.isWellness) { // Wellness Visit, no ICD
        body = {
          member: this.memberData?.id, // member's id
          doctor: this.providerId, // selected provider id
          serviceDate: this.finalVisitReportDate, // format YYYY-MM-DD
          visitType: this.isWellness ? 'well' : 'sick', // allowed values ['well', 'sick']
        }
      }
      else { // Sick Visist, with ICD
        body = {
          member: this.memberData?.id, // member's id
          doctor: this.providerId, // selected provider id
          serviceDate: this.finalVisitReportDate, // format YYYY-MM-DD
          visitType: this.isWellness ? 'well' : 'sick', // allowed values ['well', 'sick']
          icds: this.selectDiagnosis?.code // if visitType == 'sick', This field is required. (Diag codes)
        }
      }

      console.log("Body: ", body);

      api()
        .post(`/dpcproviders/visitreport`, body)
        .catch((err) => {
          this.screenLoader = false;
          if (err) {
            this.$refs.error_modal.openPopUp(err.response.data);
          }
        })
        .then((res) => {
          this.screenLoader = false;
          if(res){
            console.log("Visit Reporting: ", res.data);
            this.$refs.success_modal.openPopUp("Thank you for reporting your visit.");
          }
          
        });
    },
    newVisitReportStatus(status) {
      if(status) {
        if(status == 'pending') {
          return "newVisitReportStatus_gray" // Gray
        }
        else if(status == 'active') {
          return "newVisitReportStatus_green" // Green
        }
        else if(status == 'inactive') {
          return "newVisitReportStatus_red" // Red
        }
        else {
          return "newVisitReportStatus_red" // Red
        }
      }
      else  {
        return "newVisitReportStatus_red" // Red
      }
    },
    openDatePicker() {
      // this.visitReportDate = null;
      this.datePickerDialog = true;
    },
    clinicaltablesSearch() {
      // console.log("this.clinicaltables: ", this.clinicaltables );
      api()
        .get(`https://clinicaltables.nlm.nih.gov/api/icd10cm/v3/search?sf=code,name&terms=${this.clinicaltables}`)
        .catch((err) => {
          if (err) {
            console.log("Error: ", err)
          }
        })
        .then((res) => {
          // console.log("Results: ", res.data[3] ); // 4th Array contains the Code and Name of ICDs
          if(res.data[3]) {
            const resData = res.data[3];
            const clinicTableData = resData.map(item => {
                return {
                    code: item[0],
                    name: item[1]
                };
            });

            // Pass the clinicTableData to this.clinicaltableData for the table UI
            this.clinicaltableData = clinicTableData
            // console.log("clinicTableData: ", clinicTableData) // Final List of ICDs
          }
          else {
            console.log(`No Data related to, "${this.clinicaltables}"`);
          }
        });
    },
    selectDiagnosis(item) { // Get selected Item
      this.selectDiagnosis = item
      // console.log("Selected Diagnosis: ", item)
      // console.log("Selected Diagnosis: ", this.selectDiagnosis)
    },
  parseDate(date) {
    if (!date) return null;

    const [year, month, day] = date.split('-');
    if (year && month && day) {
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    } else {
      return null;
    }
  },
  openFavoriteModifiersDialog(){
    this.modifiersList = false;
    this.favModifiersDialog = true;
  },
  openModifiersDialog(){
    this.modifiersList = true;
    this.favModifiersDialog = false;
  },
    openDiagnosesDialog(){
      this.DiagnosisDialog = true;
      this.FavoriteDiagnosis = false;
    },
    openFavoriteDiagnosesDialog(){
      this.DiagnosisDialog = false;
      this.FavoriteDiagnosis = true;
    },
    openProcedureDialog(){
      this.ProcedureDialog = true;
      this.FavoriteProcedure = false;
    },
    openFavoriteProcedureDialog(){
      this.ProcedureDialog = false;
      this.FavoriteProcedure = true;
    },
    getMember(){
      api()
          .get(`/dpcproviders/member/`+this.$route.params.id)
          .catch((err) => {
            if (err) {
              if (err.response.status == 500) {
                this.$refs.error_modal.openPopUp(
                  "There was an error, system admin is notified. Please try again later."
                );}
              }
          })
          .then((res) => {
            this.memberData = res.data
            
          });
    },
    moveIcd(from, to) {
      this.icds.move(from, to);
    },
    moveCpt(from, to) {
      this.cpts.move(from, to);
    },
    defaultTemplate() {
      this.template = {};
      this.noTitle = 'No Template'
      this.icds= [];
      this.cpts = [];
    },
    addFavoriteModifiers(item,index =null){
        if(this.favoriteModifiers.includes(item)){
        this.favoriteModifiers = this.favoriteModifiers.filter(function (i) {
        return i != item
      })
      }else{
        this.favoriteModifiers.push(item);
      }
      if(index!=null){
        if(this.modifiers[index].star==0){
          this.modifiers[index].star = 1;
        }else{        
          this.modifiers[index].star = 0;
        }
      }
    },
    addFavoriteCpt(item,index =null){
        if(this.favoriteProcedures.includes(item)){
        this.favoriteProcedures = this.favoriteProcedures.filter(function (i) {
        return i != item
      })
      }else{
        this.favoriteCpt.push(item);
        this.favoriteProcedures.push(item);
      }
      if(index!=null){
        if(this.procedure[index].star==0){
          this.procedure[index].star = 1;
        }else{        
          this.procedure[index].star = 0;
        }
      }
    },
    manageFavoriteCpts(item,index = null){
      if(index!=null){
        const favoriteItem = this.favoriteProcedures[index];
        const procedureIndex = this.procedure.findIndex(procItem => procItem._id === favoriteItem._id);
            if (procedureIndex !== -1) {
                this.procedure[procedureIndex].star = 0;
            } 
            this.favoriteProcedures.splice(index, 1);
    }
    },
    manageFavoriteModifiers(item,index = null){
      if(index!=null){
        const favoriteItem = this.favoriteModifiers[index];
        const modIndex = this.modifiers.findIndex(modIndex => modIndex._id === favoriteItem._id);
            if (modIndex !== -1) {
                this.modifiers[modIndex].star = 0;
            } 
            this.favoriteModifiers.splice(index, 1);
    }
    },
    addFavoriteIcd(item, index=null){
      if(this.favoriteDiagnoses.includes(item)){
        this.favoriteDiagnoses = this.favoriteDiagnoses.filter(function (i) {
        return i != item
      })
      }else{
        this.favoriteIcd.push(item);
        this.favoriteDiagnoses.push(item)
      }
      if(index!=null){
        if(this.diagnose[index].star==0){
          this.diagnose[index].star = 1;
        }else{        
          this.diagnose[index].star = 0;
        }
      }
    },
    manageFavoriteIcd(item, index=null){
      if(index!=null){
        const favoriteItem = this.favoriteDiagnoses[index];
        const diagnoseIndex = this.diagnose.findIndex(diagnoseItem => diagnoseItem._id === favoriteItem._id);
            if (diagnoseIndex !== -1) {
                this.procedure[procedureIndex].star = 0;
            } 
          this.favoriteDiagnoses.splice(index, 1);
    }
    },
    getModifiers() {
      api()
        .get(`/visitreport/cptmod`)
        .then((res) => {
          this.modifiers = res.data;
          this.modifiersList = true;
        });
    },
    getFavs() {
      api()
        .get(`/dpcproviders/visitreport/favorites`)
        .then((res) => {
          this.favoriteDiagnoses = res.data.icds;
          this.favoriteProcedures = res.data.cpts;
        });
    },
    checkCptmod(item) {
      let tmpItem = this.tmpCptmod.filter(function (i) {
        return i == item._id;
      });
      if (tmpItem.length > 0 && tmpItem[0] != null) {
        this.cptmod.push(item);
      } else {
        this.icds = this.icds.filter(function (i) {
          return i._id != item._id;
        });
      }
    },
    removeFromIcds(item) {
      this.icds = this.icds.filter(function (i) {
        return i._id != item._id;
      });
      console.log(this.icds);
    },
    removeFromCpt(item) {
      this.cpts = this.cpts.filter(function (i) {
        return i._id != item._id;
      });
    },
    checkIcds(item) {
      let tmpItem = this.tmpIcds.filter(function (i) {
        return i == item._id;
      });
      if (tmpItem.length > 0 && tmpItem[0] != null) {
        this.icds.push(item);
      } else {
        this.icds = this.icds.filter(function (i) {
          return i._id != item._id;
        });
      }
    },
    checkCpts(item) {
      let tmpItem = this.tmpCpts.filter(function (i) {
        return i == item._id;
      });
      if (tmpItem.length > 0 && tmpItem[0] != null) {
        item.quantity = this.quantity;
        this.cpts.push(item);
      } else {
        this.cpts = this.cpts.filter(function (i) {
          return i._id != item._id;
        });
      }
    },
    addFavCpts() {
      let data = {
        cpts: this.favoriteCpt,
      };
      api()
        .put(`/dpcproviders/visitreport/favorites`, data)
        .then((res) => {});
    },
    addFavIcds() {
      let data = {
        cpts: this.favoriteIcd,
      };
      api()
        .put(`/dpcproviders/visitreport/favorites`, data)
        .then((res) => {});
    },
    addICDS() {
      // this.addFavIcd();
      this.DiagnosisDialog = false;

      // Search for Procedures based on diagnosis search keyword
      api()
        .get(`/visitreport/cpt?description=${this.diagnoseSearch}`)
        .catch((err) => {
        if (err) {
          this.loader=false;
          }
      })
        .then((res) => {
          // If res has value
          if (res) {
            // temporary CPTS
            this.tmpCpts = this.cpts.map(function (value, index, array) {
              return value.cpt._id;
            });

            // List of Procedures
            this.procedure = res.data.map((item) => ({
              ...item,
              star: this.favoriteProcedures.some(fav => fav._id === item._id) ? 1 : 0,
            }));
          }
        })
        .finally(() => {
          this.diagnoseSearch = "";
          this.procedureSearch = "";
        });
    },
    addCPTS() {
      //  this.addFavCpts();
      this.ProcedureDialog = false;
      let cpts = this.cpts;
      this.procedureSearch = "";
    },
    addCPTmod() {
      let cptmod = this.cptmod;
    },
    submitVisitReport() {
      const self = this;
      let data = {
        member: this.$route.params.id,
        doctor: this.providerId,
        location: this.locationId,
        serviceDate: this.dateOfService,
        icds: this.icds.map(function (value, index, array) {
          return value.code
        }),
        cptmod: this.cptmod,
        cpts: this.cpts.map(function (value, index, array) {
          return {
            // cpt: value.cpt.code,
            cpt: value.code,
            icdLink: self.icds[0].code,
            modifiers: self.cptmod.map(function (value) {
              return value.code;
            }),
          };
        }),
      };
      this.submitFavorites();

      // console.log("this.providerId: ", this.providerId);
      // console.log("this.icds: ", this.icds);
      // console.log("this.cpts: ", this.cpts);
      // console.log("data: ", data);

      if (this.providerId == null || !this.providerId) {
        this.errorProvider = true;
      } else {
        api()
          .post(`/dpcproviders/visitreport`, data)
          .catch((err) => {
            if (err) {
                this.$refs.error_modal.openPopUp(err.response.data);
              }
          })
          .then((res) => {
            if(res){
               this.$refs.success_modal.openPopUp("Visit Report Submited Successfully");
            }
           
          });
      }
    },
    getTemplates() {
      if (this.memberData == undefined || this.memberData == null) {
        this.$router.push("/dpc-providers/members");
      }
      api()
        .get(`/dpcproviders/visitreport?member=${this.$route.params.id}`)
        .then((res) => {
          this.templates = res.data.templates;
          this.template = this.templates[0];
          this.templateForEdit = this.template;
        });
    },
    searchDiagnose() {
      this.diagnose = [];
      if (
        this.diagnoseSearch == null ||
        this.diagnoseSearch == "" ||
        !this.diagnoseSearch ||
        this.diagnoseSearch == "undefined"
      ) {
        this.emptySearch = true;
      } else {
        this.loader = true;
        this.DiagnosisDialog = true;
        this.diagnoseSearch = this.diagnoseSearch.trim();
        api()
          .get(`/visitreport/icd?description=${this.diagnoseSearch}`)
          .catch((err) => {
            if (err) {
              this.loader=false;
              }
          })
          .then((res) => {
            if (res) {
              this.tmpIcds = this.icds.map(function (value, index, array) {
                return value._id;
              });
              this.loader=false;
              this.diagnose = res.data.map((item) => ({
                ...item,
                star: this.favoriteDiagnoses.some(fav => fav._id === item._id) ? 1 : 0,
              }));
            }
          })
          .finally(() => {
            this.loader=false;
          });
      }
    },
    searchProcedure() {
      if(this.procedure) {
        // Open Dialog of Procedures List
        this.ProcedureDialog = true;
        console.log("search: ", this.procedureSearch)

        // See if this.procedureSearch has value and does exists in the current procedure list
        if(this.procedureSearch) {
          const found = this.procedure.find(item => item.description === this.procedureSearch);
          if (!found) {
            this.finalProcedureSearch();
          }
          else {
            this.procedure = found;
          }
          console.log("search: ", this.procedureSearch)
          console.log("found: ", found)
        }
        else {
          console.log("search: ", this.procedureSearch)
        }
      }
      else {
        this.procedure = [];
        if (
          this.procedureSearch == null ||
          this.procedureSearch == "" ||
          !this.procedureSearch ||
          this.procedureSearch == "undefined"
        )
        {
          this.emptySearch = true;
        } 
        else {
          this.loader = true;
          if (this.icds.length == 0) {
            this.errorModal = true;
          } else {
            this.ProcedureDialog = true;
            this.procedureSearch = this.procedureSearch.trim();
            this.finalProcedureSearch();
          }
        }
      }
    },
    finalProcedureSearch() {
      api()
        .get(`/visitreport/cpt?description=${this.procedureSearch}`)
        .catch((err) => {
        if (err) {
          this.loader=false;
        }
      })
        .then((res) => {

          // Close Loader
          this.loader = false;

          // If res has value
          if (res) {
            // temporary CPTS
            this.tmpCpts = this.cpts.map(function (value, index, array) {
              return value.cpt._id;
            });

            // List of Procedures
            this.procedure = res.data.map((item) => ({
              ...item,
              star: this.favoriteProcedures.some(fav => fav._id === item._id) ? 1 : 0,
            }));
          }
        })
        .finally(() => {
          this.procedureSearch = "";
          this.loader=false;
        });
    },
    generatePdf() {
      window.open("https://api.apaly.net/terms");
    },
    showSlash(event) {
      if (this.taxId.length == 2 && event.keyCode != 8) {
        this.taxId += "-";
      }
    },
    activateFileInput() {
      this.$refs.fileInput.$refs.input.click();
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.$router.push("/dpc-providers/members/");
    },

    changeTemplate(template){
      this.noTitle = '';
      const self = this;
      this.template = template;
      this.itemIcds = this.template.icds;
      this.icds = this.template.icds;
      this.cpts = this.template.cpts;
      this.templateForEdit = template;
      this.cpts.forEach(item => {
            if (!item.hasOwnProperty('quantity')) {
          this.$set(item, 'quantity', '1');
        }
        });
    },

    editTemplate(template) {
      this.$router.push(`/dpc-providers/members/edit-template/${template._id}`);
    },

    submitIcdsFavorites() {
      let data = {
        icds: this.favoriteIcd,
      };
      api()
        .put(`/dpcproviders/visitreport/favorites`, data)
        .then((res) => {});
    },
    submitFavorites(){
      let data = {
        icds: this.favoriteDiagnoses.map(function (value, index, array) {
          return value._id;
        }),
        cpts: this.favoriteProcedures.map(function (value, index, array) {
          return value._id;
        }),
        cptmod: this.favoriteModifiers.map(function (value, index, array) {
          return value._id;
        }),
      }
      api()
            .put(`/dpcproviders/visitreport/favorites`, data)
            .then((res) => {
              console.log('resss',res)
            });
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    cancel(){
      this.$router.go(-1);
    }
  },
};
</script>
<style scoped>
.modal-member-check.v-dialog {
  margin-top: 16% !important;
}
.error-modal-red-text {
  color: rgb(228, 0, 0);
  font-weight: bold;
}
.red-error-modal {
  border: 3px solid rgb(228, 0, 0);
  font-weight: bold;
}
.inline-grid {
  display: -ms-inline-grid;
}
.zero-padding {
  padding: 0px !important;
}
.zero-padding-top {
  padding-top: 0px !important;
}
</style>
